<template>
  <div>
    <vs-row class="sdf-text-17-400-light-navy">
      <vs-col vs-type="flex" vs-align="center-end" vs-w="2"></vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span>左舷</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span>右舷</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">軸回転数</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ portShaftRpm }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ starboardShaftRpm }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">軸出力</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ portShaftPower }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ starboardShaftPower }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">軸トルク</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ portShaftTorque }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white"
        >{{ starboardShaftTorque }}</span
        >
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">FO流量</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">No.1</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ portFOFlow1 }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ starboardFOFlow1 }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">No.2</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ portFOFlow2 }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <span class="sdf-text-18-400-white">{{ starboardFOFlow2 }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">CPP翼角</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <port-cpp-pitch :value="portCppPitch"/>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <starboard-cpp-pitch :value="starboardCppPitch"/>
      </vs-col>
    </vs-row>
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-align="center" vs-w="2">
        <span class="sdf-text-18-400-light-navy">舵角</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <port-rudder-angle :value="portRudderAngle"/>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
        <starboard-rudder-angle :value="starboardRudderAngle"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import {isNumber} from "lodash";

// components
import PortRudderAngle from "./components/PortRudderAngle";
import StarboardRudderAngle from "./components/StarboardRudderAngle";
import PortCppPitch from "./components/PortCppPitch";
import StarboardCppPitch from "./components/StarboardCppPitch";

// mixins
import {
  ColorMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

const FOChannels = {
  StarboardFOFlow1: 0,
  PortFOFlow1: 1,
  StarboardFOFlow2: 2,
  PortFOFlow2: 3
};

export default {
  mixins: [
    ColorMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    PortRudderAngle,
    StarboardRudderAngle,
    PortCppPitch,
    StarboardCppPitch
  },
  props: {
    foFlowRateSum: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      foFlowValues: {
        StarboardFOFlow1: 0,
        PortFOFlow1: 0,
        StarboardFOFlow2: 0,
        PortFOFlow2: 0
      }
    };
  },
  computed: {
    portCppManeuveringLocation() {
      if (this.channelDataManeuvering) {
        return this.getManeuveringLocationLabel(
          this.channelDataManeuvering.SB22.vs
        );
      }
    },
    portMainEngine1Speed() {
      if (this.channelDataManeuvering) {
        return `${this.channelDataManeuvering.SB25.vn.toFixed(1)}rpm`;
      }
    },
    portMainEngine2Speed() {
      if (this.channelDataManeuvering) {
        return `${this.channelDataManeuvering.SB26.vn.toFixed(1)}rpm`;
      }
    },
    starboardCppManeuveringLocation() {
      if (this.channelDataManeuvering) {
        return this.getManeuveringLocationLabel(
          this.channelDataManeuvering.SB21.vs
        );
      }
    },
    starboardMainEngine1Speed() {
      if (this.channelDataManeuvering) {
        return `${this.channelDataManeuvering.SB23.vn.toFixed(1)}rpm`;
      }
    },
    starboardMainEngine2Speed() {
      if (this.channelDataManeuvering) {
        return `${this.channelDataManeuvering.SB24.vn.toFixed(1)}rpm`;
      }
    },

    portRudderAngle() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB37.vn)) {
          return Number(this.channelDataManeuvering.SB37.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    starboardRudderAngle() {
      if (this.channelDataManeuvering !== null) {
        if (isNumber(this.channelDataManeuvering.SB36.vn)) {
          return Number(this.channelDataManeuvering.SB36.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    portCppPitch() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB28.vn)) {
          return Number(this.channelDataManeuvering.SB28.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    starboardCppPitch() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB27.vn)) {
          return Number(this.channelDataManeuvering.SB27.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    starboardShaftRpm() {
      if (this.channelDataEngine) {
        if (typeof this.channelDataEngine["0103"] !== "undefined") {
          return this.channelDataEngine["0103"].vn !== null ? `${this.channelDataEngine["0103"].vn} min-1` : this.noneValue;
        } else {
          return this.noneValue;
        }
      }
    },
    portShaftRpm() {
      if (this.channelDataEngine) {
        if (typeof this.channelDataEngine[1303] !== "undefined") {
          return this.channelDataEngine[1303].vn !== null ? `${this.channelDataEngine[1303].vn} min-1` : this.noneValue;
        } else {
          return this.noneValue;
        }
      }
    },
    starboardShaftPower() {
      if (this.channelDataEngine) {
        if (typeof this.channelDataEngine["0152"] !== "undefined") {
          return this.channelDataEngine["0152"].vn !== null ? `${this.channelDataEngine["0152"].vn} kW` : this.noneValue;
        } else {
          return this.noneValue;
        }
      }
    },
    portShaftPower() {
      if (this.channelDataEngine) {
        if (typeof this.channelDataEngine[1352] !== "undefined") {
          return this.channelDataEngine[1352].vn !== null ? `${this.channelDataEngine[1352].vn} kW` : this.noneValue;
        } else {
          return this.noneValue;
        }
      }
    },
    starboardShaftTorque() {
      if (this.channelDataEngine) {
        if (typeof this.channelDataEngine["0154"] !== "undefined") {
          return this.channelDataEngine["0154"].vn !== null ? `${this.channelDataEngine["0154"].vn} kN.m` : this.noneValue;
        } else {
          return this.noneValue;
        }
      }
    },
    portShaftTorque() {
      if (this.channelDataEngine) {
        if (typeof this.channelDataEngine[1354] !== "undefined") {
          return this.channelDataEngine[1354].vn !== null ? `${this.channelDataEngine[1354].vn} kN.m` : this.noneValue;
        } else {
          return this.noneValue;
        }
      }
    },
    starboardFOFlow1() {
      if (this.channelDataEngine[2511].vn === null) return this.noneValue
      return this.foFlows.starboardFOFlow1 === -1 ? "計算中" : `${this.foFlows.starboardFOFlow1.toFixed(2)} L/h`;
    },
    portFOFlow1() {
      if (this.channelDataEngine[2513].vn === null) return this.noneValue
      return this.foFlows.portFOFlow1 === -1 ? "計算中" : `${this.foFlows.portFOFlow1.toFixed(2)} L/h`;
    },
    starboardFOFlow2() {
      if (this.channelDataEngine[2512].vn === null) return this.noneValue
      return this.foFlows.starboardFOFlow2 === -1 ? "計算中" : `${this.foFlows.starboardFOFlow2.toFixed(2)} L/h`;
    },
    portFOFlow2() {
      if (this.channelDataEngine[2514].vn === null) return this.noneValue
      return this.foFlows.portFOFlow2 === -1 ? "計算中" : `${this.foFlows.portFOFlow2.toFixed(2)} L/h`;
    }
  },
  methods: {},
  mounted() {
  }
};
</script>

<style lang="scss"></style>
